const _listeners = {};
/**
 * Subscribe to notifications about a specific topic.
 *
 * @param topic - The topic to subscribe to.
 * @param listener - The callback triggered when topic is published to.
 * @returns The unsubscribe method.
 */
export function subscribe(topic, listener) {
    if (!Object.prototype.hasOwnProperty.call(_listeners, topic))
        _listeners[topic] = [];
    const index = _listeners[topic].push(listener) - 1;
    return () => {
        delete _listeners[topic][index];
    };
}
/**
 * Publish a notification about a specific topic.
 *
 * Topic naming is app specific, but it is recommended to follow a `<category>/<event>` pattern (e.g. `document/created`, `document/deleted`), and provide specific details (like document ID) as a message.
 *
 * @param topic - The topic. Must be globally unique in your application.
 * @param message - The message. Should be an object with properties detailing the event, but this is optional and up to the application.
 * @returns
 */
export function publish(topic, message) {
    if (!Object.prototype.hasOwnProperty.call(_listeners, topic))
        return;
    _listeners[topic].forEach((l) => l && l(message));
}
